import { useState } from 'react';
import { Trans } from 'react-i18next';

import { Button } from '@actual-app/components/button';
import { Text } from '@actual-app/components/text';
import { View } from '@actual-app/components/view';

import { Icono } from '#components/mobile/ui/Icono';
import { color, radio, texto } from '#components/mobile/ui/tokens';

import { tarjetaPlana } from './tarjetaPlana';

/** «¿Qué puede hacer cada permiso?», plegada hasta que se toca. */
export function AyudaPermisos() {
  const [abierta, setAbierta] = useState(false);
  return (
    <View style={tarjetaPlana}>
      <Button
        variant="bare"
        data-testid="ayuda-permisos"
        aria-expanded={abierta}
        onPress={() => setAbierta(a => !a)}
        style={{
          borderRadius: radio.tarjeta - 4,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          minHeight: 48,
          padding: '12px 14px',
          fontSize: 14,
          fontWeight: 700,
          color: color.fg2,
          textAlign: 'left',
        }}
      >
        <Trans>What can each permission do?</Trans>
        <Icono
          nombre="cd"
          size={18}
          style={{
            transform: abierta ? 'rotate(180deg)' : undefined,
            transition: 'transform .15s',
          }}
        />
      </Button>
      {abierta && (
        <View
          style={{
            gap: 6,
            padding: '0 14px 12px',
            ...texto.secundario,
            color: color.fg2,
            '& strong': { color: color.fg },
          }}
        >
          <Text>
            <Trans>
              <strong>View and edit</strong>: adds expenses and shares out the
              money, just like you.
            </Trans>
          </Text>
          <Text>
            <Trans>
              <strong>View only</strong>: sees everything, but cannot change
              anything.
            </Trans>
          </Text>
          <Text>
            <Trans>
              Whoever is in command decides who comes aboard and who leaves.
            </Trans>
          </Text>
        </View>
      )}
    </View>
  );
}
